/**
 * Single source of truth for error reporting in the frontend.
 *
 * Anything that would do
 *
 *     try { ... } catch (e) { console.error(e); }
 *
 * calls ``logError`` instead, so every error caught is reported the same
 * way, with where it was caught.
 *
 * @param e        The thrown value (Error or anything coerced via
 *                 ``new Error(String(e))``).
 * @param context  What is said beside it. Convention: include a
 *                 ``source`` key naming the call site
 *                 (``source: "apollo.error_link"``).
 */
export function logError(
  e: unknown,
  context: Record<string, unknown> = {},
): void {
  const err = e instanceof Error ? e : new Error(String(e));
  if (Object.keys(context).length) {
    console.error(err, context);
  } else {
    console.error(err);
  }
}
